export default import.meta.ROLLUP_FILE_URL_HQ7bCSARODl8iDcs6ZrAAw